export enum LinkedCheckoutReason {
    FailedPayment = 'failed-payment',
}
